import React from 'react';
import { Col } from 'reactstrap';

const StatCol = ({ xs, children}) => {
    return (
        <Col xs={xs} className="mt-3">
            <h6 className="d-flex justify-content-center">
                {children}
            </h6>
        </Col>
    );
};

export default StatCol;
